/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { clickTrack } from '@/utils/analytics/clickTrack';
import root from 'window-or-global';
import type { OptInEvents } from '../constants/optIn';
import type { OptInValues } from '../interface';

export const trackOptIn = (event: OptInEvents, message?: string) => {
  const { pageType, pageName, siteSection } = root.utag_data || {};

  clickTrack({
    customLinkName: pageType + '-' + event,
    eventType: event,
    ...(message ? { promoEmailOffersMessage: message } : {}),
    pageName,
    pageType,
    siteSection,
  });
};

export const trackOptInModalForm = (optedFor: OptInValues[], message?: string) => {
  if (optedFor.length === 0) {
    return;
  }

  const event: OptInEvents =
    optedFor.length === 1
      ? optedFor[0] === 'EMAIL'
        ? 'optInPromoEmailOffers'
        : 'optInPromoSmsOffers'
      : 'optInPromoSMS+EmailOffers';

  trackOptIn(event, message);
};
